<div class="lum-c-sales-order-shipment-status-dialog">
  <div mat-dialog-title>
    <h4 class="modal-title">Shipment Status Details</h4>
  </div>
  <div mat-dialog-content>
    <h5>Order Number: {{ data?.salesOrderShipments[0]?.orderNumber }}</h5>
    <table class="lum-table lum-table--striped mt-4">
      <thead>
        <tr>
          <ng-container
            *ngIf="data?.ftPushUnPushToFulfilllmentChannel; else useOrderIdHeader"
          >
            <th>Source Reference Identifier</th>
          </ng-container>
          <ng-template #useOrderIdHeader>
            <th>Order ID</th>
          </ng-template>
          <th>Warehouse Group</th>
          <th>Destination OMS</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let shipment of data?.salesOrderShipments; trackBy: trackById">
          <ng-container
            *ngIf="data?.ftPushUnPushToFulfilllmentChannel; else useOrderId"
          >
            <td>{{ shipment?.sourceReferenceIdentifier }}</td>
          </ng-container>
          <ng-template #useOrderId>
            <td>{{ shipment?.orderId }}</td>
          </ng-template>
          <td>{{ shipment?.warehouseGroup?.label || 'N/A' }}</td>
          <td>{{ shipment?.destinationOms?.label || 'N/A' }}</td>
          <td>
            {{
              (shipment?.orderStatus
                | stringTransformation: stringTransformationType.CAPITALIZE) ||
                'N/A'
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    class="
      lum-c-sales-order-shipment-status-dialog-actions w-100 flex justify-content-end mt-8
    "
  >
    <button class="lum-button lum-button--tertiary" mat-dialog-close>
      Close
    </button>
  </div>
</div>
